import type { CountryInfo } from '@/services/api/ultraadmin'

export const SCHOOL_LANGUAGES = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
  { code: 'fr', label: 'Français' },
  { code: 'it', label: 'Italiano' },
  { code: 'rm', label: 'Rumantsch' },
]

export const SCHOOL_CURRENCIES = ['CHF', 'EUR'] as const

export type SchoolListChannel = 'all' | 'direct' | 'partner'

export type SchoolListFilterValue = {
  channel: SchoolListChannel
  search: string
  country: string
  language: string
  currency: string
}

export const EMPTY_SCHOOL_LIST_FILTER: SchoolListFilterValue = {
  channel: 'all',
  search: '',
  country: '',
  language: '',
  currency: '',
}

export function schoolListFilterParams(f: SchoolListFilterValue): {
  search?: string
  country?: string
  language?: string
  currency?: string
  direct?: boolean
  limit: number
} {
  const params: {
    search?: string
    country?: string
    language?: string
    currency?: string
    direct?: boolean
    limit: number
  } = { limit: 500 }
  if (f.channel === 'direct') params.direct = true
  if (f.channel === 'partner') params.direct = false
  const search = f.search.trim()
  if (search) params.search = search
  if (f.country) params.country = f.country
  if (f.language) params.language = f.language
  if (f.currency) params.currency = f.currency
  return params
}

export function schoolListFilterChips(
  f: SchoolListFilterValue,
  countries: CountryInfo[],
): { key: keyof SchoolListFilterValue; label: string }[] {
  const chips: { key: keyof SchoolListFilterValue; label: string }[] = []
  if (f.channel === 'direct') chips.push({ key: 'channel', label: 'Kanal: Direkt' })
  if (f.channel === 'partner') chips.push({ key: 'channel', label: 'Kanal: Partner' })
  if (f.search.trim()) chips.push({ key: 'search', label: `Name: ${f.search.trim()}` })
  if (f.country) {
    const name = countries.find((c) => c.code === f.country)?.name || f.country
    chips.push({ key: 'country', label: `Land: ${name}` })
  }
  if (f.language) {
    const name = SCHOOL_LANGUAGES.find((l) => l.code === f.language)?.label || f.language
    chips.push({ key: 'language', label: `Sprache: ${name}` })
  }
  if (f.currency) chips.push({ key: 'currency', label: `Währung: ${f.currency}` })
  return chips
}
